// client/src/components/admin/influencer/InfluencerBankEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function InfluencerBankEditModal({ open, onClose, influencer, onSuccess }) {
  const [formData, setFormData] = useState({
    holderName: '',
    bankName: '',
    bankNameCustom: '',
    accountNumber: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && influencer) {
      setFormData({
        holderName: influencer.bankAccount?.holderName || '',
        bankName: influencer.bankAccount?.bankName || '',
        bankNameCustom: influencer.bankAccount?.bankNameCustom || '',
        accountNumber: influencer.bankAccount?.accountNumber || ''
      });
      setError('');
    }
  }, [open, influencer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // 필드 검증
    if (!formData.holderName.trim()) {
      setError('예금주명을 입력해주세요.');
      return;
    }
    if (!formData.bankName.trim()) {
      setError('은행명을 선택해주세요.');
      return;
    }
    if (!formData.accountNumber.trim()) {
      setError('계좌번호를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/influencer/info/${influencer.userId}/bank`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.ok) {
        onSuccess();
        onClose();
      } else {
        setError(data.message || '통장 정보 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('통장 정보 수정 중 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="influencer-info-edit-modal">
      <div className="influencer-info-edit-modal__content">
        <h2 className="influencer-info-edit-modal__title">
          통장 정보 수정
        </h2>

        {/* 경고 메시지 */}
        <div className="influencer-info-edit-modal__warning">
          <div className="influencer-info-edit-modal__warning-title">⚠️ 주의사항</div>
          <div className="influencer-info-edit-modal__warning-text">
            • 처리 중인 환전 신청이 있으면 수정할 수 없습니다.<br/>
            • 기존 환전 신청은 신청 시 저장된 계좌 정보로 처리됩니다.
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 예금주명 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              예금주명 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="text"
              name="holderName"
              value={formData.holderName}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="예금주명을 입력하세요"
            />
          </div>

          {/* 은행명 */}
          <div className="influencer-info-edit-modal__field">
            <label className="influencer-info-edit-modal__label">
              은행명 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <select
              name="bankName"
              value={formData.bankName}
              onChange={handleChange}
              className="influencer-info-edit-modal__select"
            >
              <option value="">은행 선택</option>
              <option value="KB국민은행">KB국민은행</option>
              <option value="신한은행">신한은행</option>
              <option value="우리은행">우리은행</option>
              <option value="하나은행">하나은행</option>
              <option value="NH농협은행">NH농협은행</option>
              <option value="IBK기업은행">IBK기업은행</option>
              <option value="SC제일은행">SC제일은행</option>
              <option value="카카오뱅크">카카오뱅크</option>
              <option value="토스뱅크">토스뱅크</option>
              <option value="케이뱅크">케이뱅크</option>
              <option value="기타">기타(직접입력)</option>
            </select>
          </div>

          {/* 은행명 직접입력 */}
          {formData.bankName === '기타' && (
            <div className="influencer-info-edit-modal__field">
              <label className="influencer-info-edit-modal__label">
                은행명 직접입력
              </label>
              <input
                type="text"
                name="bankNameCustom"
                value={formData.bankNameCustom}
                onChange={handleChange}
                className="influencer-info-edit-modal__input"
                placeholder="은행명을 입력하세요"
              />
            </div>
          )}

          {/* 계좌번호 */}
          <div className="influencer-info-edit-modal__checkbox-wrapper">
            <label className="influencer-info-edit-modal__label">
              계좌번호 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <input
              type="text"
              name="accountNumber"
              value={formData.accountNumber}
              onChange={handleChange}
              className="influencer-info-edit-modal__input"
              placeholder="계좌번호를 입력하세요 (- 없이)"
            />
          </div>

          {/* 오류 메시지 */}
          {error && (
            <div className="influencer-info-edit-modal__error">
              {error}
            </div>
          )}

          {/* 버튼 */}
          <div className="influencer-info-edit-modal__actions">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--cancel"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--submit"
            >
              {loading ? '수정 중...' : '수정'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InfluencerBankEditModal;

